import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntSupportUserIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props}>
      <path d="M13.6771 5.05327C12.8687 2.6951 10.6323 1 8 1C5.3677 1 3.13131 2.6951 2.32287 5.05327C2.71672 5.18755 3 5.56069 3 6V10C3 10.5523 2.55228 11 2 11H1C0.447715 11 0 10.5523 0 10V6C0 5.44772 0.447715 5 1 5H1.28988C2.15043 2.10851 4.82898 0 8 0C11.171 0 13.8496 2.10851 14.7101 5H15C15.5523 5 16 5.44772 16 6V10C16 10.5523 15.5523 11 15 11H14.7101C13.9957 13.4003 12.0285 15.2611 9.56677 15.824C9.40568 15.935 9.21043 16 9 16H7C6.44772 16 6 15.5523 6 15C6 14.4477 6.44772 14 7 14H9C9.43931 14 9.81245 14.2833 9.94673 14.6771C11.6945 14.078 13.078 12.6945 13.6771 10.9467C13.2833 10.8125 13 10.4393 13 10V6C13 5.56069 13.2833 5.18755 13.6771 5.05327Z" />
      <path d="M6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7Z" />
      <path d="M10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44771 5 9 5.44772 9 6C9 6.55228 9.44771 7 10 7Z" />
      <path d="M8 11C8.8885 11 9.68679 10.6137 10.2361 10H11.4649C10.7733 11.1956 9.48057 12 8 12C6.51944 12 5.22675 11.1956 4.53513 10H5.76389C6.31321 10.6137 7.1115 11 8 11Z" />
    </SntIcon>
  );
};

export default SntSupportUserIcon;
